import {User, Poll, Recognition, RecognitionFeedComment, PollVote} from "@irati/types"

type EditableContent = Poll | Recognition | RecognitionFeedComment | PollVote

export default (item: EditableContent, user: User): boolean => {
  return "createdBy" in item && item.createdBy && item.createdBy.uuid === user.uuid
}
